import type { Color } from './helpers';
import { allColors, getColorCode } from './helpers';

export function Markers() {
    return (
        <defs>
            {allColors.map((color, index) => (
                <marker
                    id={`arrowhead-${color}`}
                    key={index}
                    markerHeight="8"
                    markerWidth="10"
                    orient="auto"
                    refX="10"
                    refY="4"
                >
                    <polygon
                        fill={getColorCode(color)}
                        points="0 0, 10 4, 0 8"
                    />
                </marker>
            ))}
        </defs>
    );
}

export function marker(color: Color) {
    return `url(#arrowhead-${color})`;
}
